type Enum = ArrayLike<unknown> | { [s: string]: unknown }

export function isInStringEnum(
  value: string,
  enumeration: Enum,
): boolean {
  return Object.values(enumeration).includes(value)
}
